import { useEffect, useState } from "react";
import CSS from "./static/css/TrashcanIcon.module.css";
import delete_icon_img from "./static/img/delete_icon_16@2x.png";
import { isHiddenType } from "../../../../Common/interface/Common.interface";
import { isHiddenClassNameSetter } from "../../../../Common/ts/commonTools";

const TrashcanIcon = (
    {
        onClick,
        size,
        isHidden,
    }:{
        onClick?: () => void;
        size?: "large" | "small" | "full_heigth"
        isHidden?: isHiddenType;
    }
) => {
    const [mainClassName, setMainClassName] = useState<string>(classNameSetter().join(" "));

    function classNameSetter(){
        let RTN: string[] = [];

        if(onClick){
            RTN.push("g_click_event_item");
        }

        if(isHidden){
            RTN = isHiddenClassNameSetter({
                classNameList: RTN,
                isHidden
            })
        }

        RTN.push(CSS.l_TrashcanIcon_main);
        
        if(size){
            RTN.push(CSS.size);
            RTN.push(CSS[size]);
        }

        return RTN;
    }

    useEffect(() => {
        setMainClassName(classNameSetter().join(" "));
    }, [size, isHidden, onClick])

    return(
        <div 
            className={mainClassName}
            onClick={onClick}
        >
            <img 
                className={CSS.l_TrashcanIcon_img}
                src={delete_icon_img}
            />
        </div>
    )
}

export default TrashcanIcon;